import axios from '@/libs/axios'

export default {
    setPusherInstance(state, value) {
        state.pusherInstance = value
    },
    addChannel(state, value) {
        state.channels = {...state.channels, ...value}
    },
}